import React from 'react';
import PropTypes from 'prop-types';

import CardsListItem from 'styled/ItemCard/CardsListItem';
import CardImage from 'styled/ItemCard/CardImage';
import Title from 'styled/ItemCard/Title';
import ItemInfo from 'styled/ItemCard/ItemInfo';

import EditArModel from 'admin-editor/containers/EditArModel';

class ARItem extends React.PureComponent {
  state = {
    isEditModalOpen: false,
  }

  get date() {
    return new Date(this.props.createdAt * 1000).toLocaleString('ru-RU', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'Europe/Moscow',
    });
  }

  handleEditModalClose = () => {
    this.setState({ isEditModalOpen: false });
  }

  handleCardClick = () => {
    this.setState({ isEditModalOpen: true });
  }

  render() {
    return (
      <React.Fragment>
        <CardsListItem onClick={this.handleCardClick}>
          <CardImage src={this.props.coverUrl} alt={this.props.title} />

          <Title>{this.props.title}</Title>

          <ItemInfo style={{ opacity: 0.6 }}>{this.props.createdAt && this.date}</ItemInfo>
        </CardsListItem>

        {this.state.isEditModalOpen && (
          <EditArModel
            id={this.props.id}
            onClose={this.handleEditModalClose}
            onUpdate={this.props.onUpdate}
            onDelete={this.props.onDelete}
          />
        )}
      </React.Fragment>
    );
  }
}

ARItem.propTypes = {
  id: PropTypes.string.isRequired,
  coverUrl: PropTypes.string,
  title: PropTypes.string,
  createdAt: PropTypes.number,
  onDelete: PropTypes.func,
  onUpdate: PropTypes.func,
};

ARItem.defaultProps = {
  coverUrl: '',
  title: '',
  createdAt: undefined,
  onDelete: () => {},
  onUpdate: () => {},
};

export default ARItem;
